var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "input input--radio" }, [
    _c(
      "label",
      {
        staticClass: "input--radio__label",
        attrs: { tabindex: "0" },
        on: {
          keydown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
            )
              return null
            $event.preventDefault()
            return _vm.select.apply(null, arguments)
          },
        },
      },
      [
        _c(
          "div",
          { staticClass: "input--radio__label__content" },
          [
            _vm.label
              ? _c("span", [_vm._v(_vm._s(_vm.label))])
              : _vm._t("default"),
            _c("input", {
              ref: "radio",
              attrs: { type: "radio", disabled: _vm.disabled },
              domProps: { value: _vm.value, checked: _vm.state },
              on: { change: _vm.onChange },
            }),
            _c("span", { staticClass: "input--radio__button" }),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }